module.exports = __webpack_public_path__ + "static/media/cap4-03-desk.b80dea73.png";